import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormattedMessage} from "react-intl";

interface Props {
    period: number;
    switchToPreviousPeriod: () => void;
    switchToNextPeriod: () => void;
}

export default class CustomerOfferPeriodSwitcherArrows extends Component<Props> {
    render(): JSX.Element {
        return (
            <div className="period-controls-arrows d-md-none">
                {
                    this.props.period >= 0 &&
                        <span className="arrow mr-4" onClick={this.props.switchToPreviousPeriod}>
                            <FontAwesomeIcon icon="chevron-left"/>
                        </span>
                }

                <span className="active-period">
                    {this.period()}
                </span>

                {
                    this.props.period <= 0 &&
                        <span className="arrow ml-4" onClick={this.props.switchToNextPeriod}>
                            <FontAwesomeIcon icon="chevron-right"/>
                        </span>
                }
            </div>
        );
    }

    private period = (): JSX.Element => {
        if (this.props.period < 0) {
            return <FormattedMessage id="rewards.previous_title"/>;
        } else if (this.props.period > 0) {
            return <FormattedMessage id="rewards.upcoming_title"/>;
        } else {
            return <FormattedMessage id="rewards.current_title"/>;
        }
    };
}